import React, { useState, useEffect } from "react";

const FilePreview = ({
  file
}) => {

  const [textContent, setTextContent] = useState(null);
  const [isLoadingText, setIsLoadingText] = useState(false);
  const [pdfError, setPdfError] = useState(false);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [isLoadingPdf, setIsLoadingPdf] = useState(false);

  const fileType = getFileType(file.url);
  const fileName = file.name?.includes("_")
    ? file.name?.split("_").slice(1).join("_")
    : file.name;

  useEffect(() => {
    if (fileType === 'text') {
      setIsLoadingText(true);
      fetch(file.url)
        .then(response => response.text())
        .then(text => {
          setTextContent(text);
          setIsLoadingText(false);
        })
        .catch(error => {
          console.error('Error loading text file:', error);
          setIsLoadingText(false);
        });
    }
  }, [file.url, fileType]);

  useEffect(() => {
    if (fileType === 'pdf') {
      setIsLoadingPdf(true);
      const loadPdf = async () => {
        try {
          const res = await fetch(file.url);
          const blob = await res.blob();
          const url = URL.createObjectURL(blob);
          setPdfUrl(url);
          setIsLoadingPdf(false);
        } catch (error) {
          console.error('Error loading PDF:', error);
          setPdfError(true);
          setIsLoadingPdf(false);
        }
      };
      loadPdf();

      return () => {
        if (pdfUrl) {
          URL.revokeObjectURL(pdfUrl);
        }
      };
    }
  }, [file.url, fileType]);

  switch (fileType) {
    case 'image':
      return (
        <img
          src={file.url}
          alt={fileName}
          className="img-fluid"
          style={{
            borderRadius: "0.25rem",
            maxWidth: "100%",
            maxHeight: "400px",
            cursor: "pointer"
          }}
          onClick={() => window.open(file.url, "_blank")}
        />
      );
    case 'video':
      return (
        <video
          controls
          style={{
            borderRadius: "0.25rem",
            maxWidth: "100%",
            maxHeight: "400px"
          }}
        >
          <source src={file.url} />
        </video>
      );
    case 'audio':
      return (
        <audio
          controls
          className="w-100"
          style={{ maxWidth: "400px" }}
        >
          <source src={file.url} />
        </audio>
      );
    default:
      return null;
    /* Temp hide 260201
    case 'pdf':
      return (
        <>
          {isLoadingPdf ? (
            <div className="text-center p-4" style={{ border: "1px solid #ddd", borderRadius: "0.25rem" }}>
              <i className="fas fa-spinner fa-spin fa-2x text-primary" />
              <p className="mt-2">Cargando PDF...</p>
            </div>
          ) : !pdfError && pdfUrl ? (
            <embed
              src={pdfUrl}
              type="application/pdf"
              width="100%"
              height="600px"
              style={{
                border: "1px solid #ddd",
                borderRadius: "0.25rem"
              }}
            />
          ) : (
            <div className="text-center p-4" style={{ border: "1px solid #ddd", borderRadius: "0.25rem" }}>
              <i className="fas fa-file-pdf fa-3x text-danger mb-3" />
              <p className="text-muted">No se puede previsualizar el PDF</p>
              <button
                className="btn btn-primary btn-sm"
                onClick={() => window.open(file.url, "_blank")}
              >
                <i className="fas fa-external-link-alt mr-2" />
                Abrir PDF
              </button>
            </div>
          )}
        </>
      );
    case 'html':
      // The page as it renders, not its source. Scripts run so a prototype looks like
      // itself, but the frame gets no same-origin access: it cannot reach this app.
      return (
        <iframe
          src={file.url}
          title={fileName}
          sandbox="allow-scripts"
          style={{
            width: "100%",
            height: "420px",
            border: "1px solid #ddd",
            borderRadius: "0.25rem",
            backgroundColor: "#fff"
          }}
        />
      );
    case 'text':
      return (
        <div
          style={{
            border: "1px solid #ddd",
            borderRadius: "0.25rem",
            backgroundColor: "#f8f9fa",
            maxHeight: "400px",
            overflow: "auto"
          }}
        >
          {isLoadingText ? (
            <div className="text-center p-4">
              <i className="fas fa-spinner fa-spin fa-2x text-primary" />
              <p className="mt-2">Cargando archivo...</p>
            </div>
          ) : textContent ? (
            <pre className="p-3 m-0" style={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }}>
              {textContent}
            </pre>
          ) : (
            <div className="text-center p-4">
              <i className="fas fa-exclamation-triangle fa-2x text-warning" />
              <p className="mt-2">Error al cargar el archivo</p>
            </div>
          )}
        </div>
      );
    case 'word':
    case 'excel':
    case 'powerpoint':
      return (
        <iframe
          src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(file.url)}`}
          style={{
            width: "100%",
            height: "500px",
            border: "1px solid #ddd",
            borderRadius: "0.25rem"
          }}
          title={fileName}
        />
      );
    */
  }

}

const getFileType = (url) => {
  if (!url) return 'other';
  const lowerUrl = url.toLowerCase();
  if (lowerUrl.match(/\.(jpeg|jpg|gif|png|svg|webp|bmp)$/)) return 'image';
  if (lowerUrl.match(/\.(mp4|webm|ogg|mov|avi)$/)) return 'video';
  if (lowerUrl.match(/\.(mp3|wav|ogg|m4a|aac)$/)) return 'audio';
  if (lowerUrl.match(/\.(pdf)$/)) return 'pdf';
  if (lowerUrl.match(/\.(doc|docx)$/)) return 'word';
  if (lowerUrl.match(/\.(xls|xlsx)$/)) return 'excel';
  if (lowerUrl.match(/\.(ppt|pptx)$/)) return 'powerpoint';
  if (lowerUrl.match(/\.(zip|rar|7z|tar|gz)$/)) return 'archive';
  if (lowerUrl.match(/\.(html?)$/)) return 'html';
  if (lowerUrl.match(/\.(txt|md|json|xml|csv|js|jsx|ts|tsx|css|scss|py|rb|go|java|php|sql|sh|ya?ml|ini|toml|log|env|conf)$/)) return 'text';
  return 'other';
};



export { getFileType, FilePreview };